import { render } from "./HeroiconsSolidTruck.vue?vue&type=template&id=5ac59f1a"
const script = {}

import exportComponent from "C:\\wamp64\\www\\systems\\nova-erp-system\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidTruck.vue"]])

export default __exports__